export const imageResize = (imageWidth, imageHeight, itemWidth, itemHeight) => {
    const imageWidthProperties = imageWidth / itemWidth;
    const imageHeightProperties = imageHeight / itemHeight;

    const resizeProperties =
        imageWidthProperties < imageHeightProperties
            ? imageWidthProperties
            : imageHeightProperties;

    return {
        width: imageWidth / resizeProperties,
        height: imageHeight / resizeProperties,
    };
};

export const clickSelectItem = (element: number, previewSelected, previewSetSelected) => {
    if (previewSelected.includes(element)) {
        previewSetSelected([
            ...previewSelected.filter((item) => item != element),
        ]);
    } else {
        previewSetSelected([...previewSelected, element]);
    }
};

export const getHeightPreview = (previewWidth: number, previewHeight, elementWidth: number): number => {
    if (previewHeight === previewWidth) return elementWidth;

    if(previewWidth < previewHeight) return elementWidth * (previewHeight / previewWidth)

    if(previewWidth > previewHeight) return elementWidth / (previewWidth / previewHeight); 
   
    return 0;
}

export const getPositionPreview = (
    previewTop, previewLeft, 
    previewHeight, previewWidth, 
    previewElementHeight, previewElementWidth
) => {
    let top = 0;
    let left = 0;
   
    if(previewLeft) {
        if(previewLeft > 0) {
            left = previewLeft * (previewWidth / previewElementWidth);
        } 
        
        if(previewLeft < 0) {
            left = previewLeft / (previewWidth / previewElementWidth);
        }
    }

    if(previewTop) {
        if(previewTop > 0) {
            top = previewTop * (previewHeight / previewElementHeight);
        } 
        
        if(previewTop < 0) {
            top = previewTop / (previewHeight / previewElementHeight);
        }
    }

    return { top: top, left: left }
}